import script from "./OA.vue?vue&type=script&setup=true&lang=js"
export * from "./OA.vue?vue&type=script&setup=true&lang=js"

import "./OA.vue?vue&type=style&index=0&id=6814d9b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6814d9b7"]])

export default __exports__